export default __webpack_public_path__ + "static/media/quetion-text.1c2dcdb6.svg";